import { GENERIC_VARIATION } from '../../../../connector/connector-form/constants/constants';
import { KafkaVariations } from './model';
import { EntityVariationData } from '../../../../connector/connector-form/interfaces/entityVariationData';


export const KAFKA_VARIATIONS: EntityVariationData[] = [
  {
    name: 'Apache Kafka',
    value: GENERIC_VARIATION,
    description: 'Select this option if you use a generic kafka.',
    displayName: 'Apache Kafka',
    docLink: '/sources/streaming/kafka/apache-kafka/'
  },
  {
    name: 'Confluent Cloud',
    value: KafkaVariations.CONFLUENT_CLOUD,
    description: 'Select this option if you use Kafka Confluent cloud provider.',
    displayName: 'Kafka Confluent Cloud',
    docLink: '/sources/streaming/kafka/kafka-confluent-cloud/'
  }
];
